import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import template from './create-company-info.vue';
import { Action } from '@/store';
import apiService from '@/services/api.service';

@Component({
  mixins: [template],
})
export default class CreateCompanyInfo extends Vue {
  @Prop() company: any;
  emailError: boolean = false;;
  emptyError: boolean = false;
  emailExistsError: boolean = false;

  @Watch('company.user.email')
  checkEmail(email: string) {
    if (this.emailError && /.+@.+\.[a-zA-Z]+/.test(email)) {
      this.emailError = false;
    }
    this.emailExistsError = false;
  }

  async next(): Promise<void> {
    this.emptyError = false;
    this.emailError = false;

    if (!this.company.companyName.length || !this.company.user.email.length || !this.company.user.firstName.length || !this.company.user.lastName.length) {
      this.emptyError = true;
    }

    if (this.company.user.email.length && !/.+@.+\.[a-zA-Z]+/.test(this.company.user.email)) {
      this.emailError = true;
    }

    if (!this.emptyError && !this.emailError) {
      try {
        await apiService.checkEmail(this.company.user.email);
        this.$emit('next');
      } catch (e) {
        if (e.message === 'email already exists') {
          this.emailExistsError = true;
        } else {
          this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.company.create_error', type: 'danger' });
        }
      }
    }
  }
}